import { Injectable } from '@angular/core'

import { Kit } from 'app/_shared/interfaces/Kit'

import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class KitService extends ApiService {
  getKitByToken(storefrontId: string, token: string) {
    return this.get<Kit>(`${this.apiUrl}/storefronts/${storefrontId}/product-kits/token/${token}`, {
      params: {
        'relations[]': [
          'products.productThumbnail',
          'products.productVariants.variantThumbnail',
          'banner'
        ]
      }
    })
  }
}
